module.exports = __webpack_public_path__ + "img/T6-C-xh_7.8cfab3c3.png";